import 'bootstrap/dist/css/bootstrap.min.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import './i18n/i18n'; 
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";


const container = document.getElementById('root');

// hydrateRoot lets React adopt the prerendered HTML (see scripts/prerender.js)
// instead of wiping and re-rendering it from scratch, which avoids a flash on
// load. Falls back to a normal client render if the page was served without
// prerendered markup inside #root (e.g. local `npm start`).
if (container.hasChildNodes()) {
  ReactDOM.hydrateRoot(
    container,
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
} else {
  const root = ReactDOM.createRoot(container);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}
